import { Fragment } from "react";
import { FiltersProvider } from "../../../components/providers/FiltersProvider";
import PageHeader from "../../../layout/shared/page-header";
import { menuRoutes } from "../../../router/menu";
import ListCalls from "./ListCalls";

const CallListWrapper = () => {

    const breadCrumb = [
        { name: 'Ventas' },
        { name: 'Gestión de llamadas' },
        { name: 'Llamadas', href: menuRoutes.calls.path },
    ];

    return (
        <Fragment>
            <FiltersProvider>
                <PageHeader title="Listado de llamadas" breadcrumb={breadCrumb} />
                <ListCalls />
            </FiltersProvider>
        </Fragment>
    );
}

export default CallListWrapper;